import { useTranslation } from "react-i18next";
import { Logo } from "@/components/Logo";

export default function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer style={{ borderTop: `1px solid rgba(0,0,0,0.06)`, padding: "40px 20px" }}>
      <div style={{ maxWidth: "1152px", margin: "0 auto", textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px" }}>
          <Logo iconSize={20} />
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "4px 16px", marginBottom: "16px" }}>
          {[
            { href: "/about", label: t("footer.about") },
            { href: "/privacy", label: t("footer.privacy") },
            { href: "/terms", label: t("footer.terms") },
            { href: "/tax-info", label: t("footer.taxGuide") },
            { href: "mailto:contact@debtbridge.org", label: t("footer.contact") },
          ].map(({ href, label }, i, arr) => (
            <span key={href} style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <a
                href={href}
                style={{ fontSize: "12px", fontWeight: 300, color: "hsl(var(--muted-foreground))", textDecoration: "none", borderBottom: "1px solid transparent", transition: "border-color 0.2s" }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderBottomColor = "currentColor"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderBottomColor = "transparent"; }}
              >{label}</a>
              {i < arr.length - 1 && <span style={{ fontSize: "12px", color: "hsl(var(--muted-foreground))", opacity: 0.4 }}>·</span>}
            </span>
          ))}
        </div>
        <p style={{ fontSize: "12px", fontWeight: 300, color: "hsl(var(--muted-foreground))", letterSpacing: "0.01em", marginBottom: "6px" }}>
          {t("footer.copyright")}
        </p>
        <p style={{ fontSize: "11px", fontWeight: 300, color: "hsl(var(--muted-foreground))", opacity: 0.65, maxWidth: "560px", margin: "0 auto", lineHeight: 1.6 }}>
          {t("footer.disclaimer")}
        </p>
        <div style={{ marginTop: "20px" }}>
          <a
            href="/admin-entry"
            style={{ fontSize: "10px", color: "hsl(var(--muted-foreground))", opacity: 0.25, textDecoration: "none", letterSpacing: "0.05em" }}
          >A</a>
        </div>
      </div>
    </footer>
  );
}
